import React from 'react'
import "../../_css/help.css";

const Training = () => {
    const handleDownload = () => {
      window.open(
        "https://teacher-tech.s3.us-east-2.amazonaws.com/pdfs/TopMarks_Training_Brochure+(6).pdf",
        "_blank",
        "noopener,noreferrer"
      );
   
      };
  return (
    <div className="help-main">
         <div className="help-overview-head">
        <div className="help-overview-head-left">Instructions</div>
        <div className="help-overview-head-right">
          <button onClick={handleDownload} className="help-download-btn">
            Download Brochure
          </button>
        </div>
      </div>
      <div className="help-content">
        <h1 className="help-main-title">Getting Started</h1>
        <h3 className="help-main-subtitle">
          Welcome to SwishAI, please follow the instructions below to
          ensure that you receive the best results from the system and enjoy the
          best experience with it.
        </h3>
        {/* 1. UPLOAD ANSWER SHEETS */}
        <div className="help-section">
          <h2 className="help-section-title">1. UPLOAD ANSWER SHEETS</h2>
          <img
            src="/TT_help_upload_answer_sheet.png"
            alt="Upload Answer Sheets"
            className="help-section-image"
          />
          <div className="help-section-description">
            Click on the various TABS to Upload your Answer Sheets, Memo &
            Question Paper. You will need to Upload all 3 of these items for the
            AI to work accurately. You can scan the answer sheets all into 1
            PDF, the AI will separate them into the separate pupils names when
            marking. When you scan the answer papers, ensure you scan the pages
            in the correct sequence (ie Page 1,2,3 etc).{" "}
          </div>
          <div className="help-step-item">
            At the CLASS tab, select the correct Grade
          </div>
          <div className="help-step-item">
            At the SUBJECT tab, either select or type in the subject
          </div>
          <div className="help-step-item">
            At the EXAM NAME tab, type in the name of the test or exam for your
            reference.
          </div>
          <div className="help-step-item">
            Click on the CONTINUE tab once you've done this.
          </div>
        </div>

        {/* 2. UPLOAD HISTORY */}
        <div className="help-section">
          <h2 className="help-section-title">2. UPLOAD HISTORY</h2>
          <img
            src="/help/TT_help_2.png"
            alt="Upload Answer Sheets"
            className="help-section-image"
          />
          <div className="help-section-description">
            After you see the UPLOAD SUCCESSFUL notification, scroll down to the
            UPLOAD HISTROY section and you’ll see next to your recently uploaded
            papers it will say PROCESSING.{" "}
          </div>

          <div className="help-section-description">
            Once the AI has marked all of the papers, you’ll receive an email
            notifying you of this. It will now say COMPLETED and you can click
            on this tab to see the results (you might need to refresh the page).
          </div>
        </div>

        {/* 3. STUDENTS’ PAPERS */}
        <div className="help-section">
          <h2 className="help-section-title">3. STUDENT PAPERS</h2>
          <img
            src="/help/TT_help_3.png"
            alt="Upload Answer Sheets"
            className="help-section-image"
          />
          <div className="help-section-description">
            The AI will automatically separate your students’ papers if you’ve
            scanned them all into one PDF file. Here you can click on the VIEW
            tab and it will take you into the students marked paper.{" "}
          </div>
          <img
            src="/help/TT_help_3_1.png"
            alt="Upload Answer Sheets"
            className="help-section-image"
          />

          <div className="help-section-description">
            The DEFAULT VIEW shows you the paper as you see it above.
          </div>
          <div className="help-section-description">
            If you want to alter a students grade or if you want to leave a
            comment by a particular question, the click in the VIEW tab within
            the question. Here you can alter the grade given by the AI or you
            can leave a comment. Please remember to click the SAVE button when
            you are finished so this ensures that the changes are saved.
          </div>
          <div className="help-section-description">
            If you click on the PDF VIEW, it will show you the original answer
            pages.
          </div>
          <div className="help-section-description">
            If you click on the GENERATE FEEDBACK tab, you can see the feedback
            that the AI has generated.
          </div>

          <div className="help-section-description">
            Please click on the pencil icon to make any changes and then
            remember to click the SAVE AS DRAFT tab to save your changes.
          </div>
        </div>

        {/* 4. AI FEEDBACK */}
        <div className="help-section">
          <h2 className="help-section-title">4. AI FEEDBACK</h2>
          <img
            src="/help/TT_help_4.png"
            alt="Upload Answer Sheets"
            className="help-section-image"
          />
          <div className="help-section-description">
            Once the AI has marked the papers, you can go into the AI Feedback
            section and you can either EDIT or VIEW the feedback that the AI is
            giving the pupil. This feedback is automatically generated per pupil
            by the system however if you click on the EDIT tab, you can add your
            own comments.{" "}
          </div>

          <div className="help-section-description">
            Click SAVE once you have made your changes.
          </div>

          <div className="help-section-description">
            Please click on the SELECT CLASS dropdown box on the and enter the
            Grade that you would to like to search for. You can also enter the
            Test / Exam Subject in the adjacent box to refine your search.
          </div>
        </div>

        {/* 5. STUDENT REPORTS */}
        <div className="help-section">
          <h2 className="help-section-title">5. STUDENT REPORTS</h2>
          <img
            src="/help/TT_help_5.png"
            alt="Upload Answer Sheets"
            className="help-section-image"
          />
          <div className="help-section-description">
            To view the students reports, click on the VIEW tab in the STUDENTS
            REPORTS section.
          </div>
          <img
            src="/help/TT_help_5_1.png"
            alt="Upload Answer Sheets"
            className="help-section-image"
          />
          <div className="help-section-description">
            This opens up the individual pupil’s screen. Click on the following
            tabs to access the following functionality:
          </div>

          <div className="help-step-item">
            DOWNLOAD PDF – Download the pupils test results in a PDF Format
          </div>
          <div className="help-step-item">
            DOWNLOAD WORD - Download the pupils test results in WORD Format
          </div>
          <div className="help-step-item">
            SHARE – This will email the pupils test results to your registered
            email address. You can then email this onto the parents for record
            keeping.
          </div>
          <div className="help-step-item">
            FEEDBACK – Shows you what the AI feedback is
          </div>
          <div className="help-step-item">
            VIEW – View the individual answer. Here you can EDIT the marks
            allocated and also add comments per individual question.
          </div>
          <div className="help-step-item">
            TEACHERS REMARKS – As the Educator, you can add your own comments
            here and they’ll appear on the test results.
          </div>
          <div className="help-step-item">
            Ensure to click the SAVE REMARKS button after typing your comments.
          </div>
        </div>

        {/* 6. DOWNLOADING ANALYTIC DATA */}
        <div className="help-section">
          <h2 className="help-section-title">6. DOWNLOADING ANALYTIC DATA</h2>
          <img
            src="/help/TT_help_6.png"
            alt="Upload Answer Sheets"
            className="help-section-image"
          />
          <div className="help-section-description">
            In the CLASS SUMMARY Section, select your Grade and the Subject that
            you would like. Then click on the EXPORT ANALYTICS tab and the
            system generates an Excel File and then it will download to your
            computer.{" "}
          </div>

          <div className="help-section-description">
            This gives you all of the pupil’s marks per question so you can
            analyse the data for your test and class. This is an editable file
            so you can use the information that you need and alter the file or
            format if necessary.
          </div>
        </div>

        {/* 7. HELPFUL HINTS! */}
        <div className="help-section">
          <h2 className="help-section-title">7. HELPFUL HINTS!</h2>
          <img
            src="/help/TT_help_7.png"
            alt="Upload Answer Sheets"
            className="help-section-image"
          />
          <div className="help-section-description">
            Avoid uploading papers that have already been marked or moderated.
            This could confuse the AI system as it could struggle to
            differentiate between the pupil’s writing and the teachers marking
            and comments.
          </div>

          <img
            src="/help/TT_help_7_1.png"
            alt="Upload Answer Sheets"
            className="help-section-image"
          />
          <div className="help-section-description">
            Ensure that when you scan the papers, they are clear and it is
            legible otherwise the AI system won’t be able to read the paper and
            it could mark it incorrectly
          </div>

          <img
            src="/help/TT_help_7_2.png"
            alt="Upload Answer Sheets"
            className="help-section-image"
          />
          <div className="help-section-description">
            For best results, use a separate question and answer sheet, try to
            avoid having the questions and the answers on the same page. Rather
            upload a separate question paper and answer sheet.
          </div>

          <img
            src="/help/TT_help_7_3.png"
            alt="Upload Answer Sheets"
            className="help-section-image"
          />
          <div className="help-section-description">
            When you scan in your pupil’s papers, make sure you scan them in
            sequence (ie page 1,2,3 etc). The first page must have the pupil’s
            name on top of it then the AI knows it is a new test / exam paper
            and it will separate them accordingly.
          </div>
        </div>
      </div>
    </div>
  )
}

export default Training